// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"43":"40faefd1","162":"31afa164","506":"d0bc6df4"}[chunkId] + ".css";
};